// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0985cc16","455":"1afcd2ce","977":"2aacbf3f"}[chunkId] + ".chunk.js";
};